import { render } from "./GPTSettings.vue?vue&type=template&id=19faeabf&ts=true"
import script from "./GPTSettings.vue?vue&type=script&lang=ts"
export * from "./GPTSettings.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__